/* ============================================================
   BYO Custom Header JS
   All selectors use byo- prefix to avoid theme conflicts.
   Loaded async from the header section and initialised the moment the
   header markup exists - NOT on DOMContentLoaded, which on this theme only
   fires after every deferred module script has downloaded, so the menus
   were dead until the whole page had loaded. byo-custom-header.css keeps a
   CSS :hover fallback for the menus until html.byo-nav-js is set here.
   ============================================================ */

(function () {
function byoHeaderInit() {
  var headerEl = document.querySelector('.byo-header');
  if (!headerEl || headerEl.hasAttribute('data-byo-init')) return;
  headerEl.setAttribute('data-byo-init', '');
  document.documentElement.classList.add('byo-nav-js');

  /* ── Prevent roll-down animation on initial page load ──
     The theme's header-container.js adds header-down to <body> which
     triggers a transform on <header>. By default our CSS has NO transition
     on .byo-header, so the initial transform applies instantly (no animation).
     After 800ms we enable transitions for smooth scroll-up/down behaviour. */
  var header = document.querySelector('.byo-header');
  if (header) {
    setTimeout(function() {
      header.classList.add('byo-transitions-ready');
    }, 800);
  }

  /* ── Vertical tab switching — aim-aware hover intent ──
     Tracks mouse direction: if the user is moving rightward (toward the
     content panel), we suppress tab switches so they can cut diagonally
     across tabs without accidentally changing the active panel.
     Only switches when the mouse is moving mostly vertically (browsing tabs)
     or has paused on a tab for 100ms. */
  var tabHoverTimer;
  var lastMouseX = 0;
  var lastMouseY = 0;
  var mouseTrackTimer;

  // Track mouse position inside vtabs area
  document.querySelectorAll('.byo-mega-vtabs').forEach(function(vtabs) {
    vtabs.addEventListener('mousemove', function(e) {
      lastMouseX = e.clientX;
      lastMouseY = e.clientY;
    });
  });

  document.querySelectorAll('.byo-mega-vtab[data-panel]').forEach(function(tab) {
    tab.addEventListener('click', function() {
      if (tab.classList.contains('byo-active')) return;
      var panelId = tab.getAttribute('data-panel');
      var menu = tab.closest('.byo-megamenu');
      if (!menu) return;
      menu.querySelectorAll('.byo-mega-vtab').forEach(function(t) { t.classList.remove('byo-active'); });
      tab.classList.add('byo-active');
      menu.querySelectorAll('.byo-mega-panel').forEach(function(p) { p.classList.remove('byo-active'); });
      var target = document.getElementById(panelId);
      if (target) target.classList.add('byo-active');
    });

    tab.addEventListener('mouseenter', function(e) {
      clearTimeout(tabHoverTimer);
      var t = tab;
      var enterX = e.clientX;
      var enterY = e.clientY;

      tabHoverTimer = setTimeout(function() {
        // Compare mouse position now vs when we entered the tab
        var dx = lastMouseX - enterX;
        var dy = Math.abs(lastMouseY - enterY);

        // If mouse is moving strongly rightward (toward content panel),
        // skip the switch — user is aiming for the content area
        if (dx > 6 && dx > dy * 1.5) return;

        t.click();
      }, 100);
    });
  });

  // Cancel pending tab switch when mouse enters the content panel
  document.querySelectorAll('.byo-mega-content').forEach(function(content) {
    content.addEventListener('mouseenter', function() {
      clearTimeout(tabHoverTimer);
    });
  });

  /* ── Reposition megamenu if it overflows the viewport ── */
  function adjustMenuPosition(menu) {
    menu.style.left = '0';
    var rect = menu.getBoundingClientRect();
    var overflowRight = rect.right - window.innerWidth + 12;
    if (overflowRight > 0) {
      menu.style.left = -overflowRight + 'px';
    }
    rect = menu.getBoundingClientRect();
    if (rect.left < 12) {
      menu.style.left = (parseFloat(menu.style.left || 0) + (12 - rect.left)) + 'px';
    }
  }

  /* ── Robust megamenu open/close with delay ── */
  var navItems = document.querySelectorAll('.byo-nav-item');
  function showMenu(item, menu) {
      navItems.forEach(function(other) {
        if (other !== item) {
          var otherMenu = other.querySelector('.byo-megamenu');
          if (otherMenu) {
            otherMenu.style.display = 'none';
            otherMenu.style.left = '0';
            otherMenu.classList.remove('byo-animate-in');
          }
        }
      });
      menu.classList.remove('byo-animate-in');
      menu.style.display = 'flex';
      // Trigger reflow then add animation class
      menu.offsetHeight;
      menu.classList.add('byo-animate-in');
      adjustMenuPosition(menu);
  }
  navItems.forEach(function(item) {
    var menu = item.querySelector('.byo-megamenu');
    if (!menu) return;
    var timeout;

    item.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      showMenu(item, menu);
    });

    item.addEventListener('mouseleave', function() {
      timeout = setTimeout(function() {
        menu.style.display = 'none';
        menu.style.left = '0';
        menu.classList.remove('byo-animate-in');
      }, 250);
    });
  });
  // If the pointer is already resting on a nav item (the CSS :hover fallback
  // was showing its menu), take it over so the menu doesn't blink off.
  var hoveredMenu = document.querySelector('.byo-nav-item:hover .byo-megamenu');
  if (hoveredMenu) showMenu(hoveredMenu.closest('.byo-nav-item'), hoveredMenu);

  /* ── Helper: close a megamenu and return focus to its trigger ── */
  function closeMegamenu(navItem) {
    var menu = navItem.querySelector('.byo-megamenu');
    if (menu) {
      menu.style.display = 'none';
      menu.style.left = '0';
      menu.classList.remove('byo-animate-in');
    }
    var trigger = navItem.querySelector('.byo-nav-link');
    if (trigger) trigger.focus();
  }

  /* ── Keyboard: open megamenu on Enter/Space/ArrowDown from nav link ── */
  navItems.forEach(function(item) {
    var link = item.querySelector('.byo-nav-link');
    var menu = item.querySelector('.byo-megamenu');
    if (!link || !menu) return;

    link.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        // Only intercept if this nav item has a megamenu
        e.preventDefault();
        // Close any other open menus
        navItems.forEach(function(other) {
          if (other !== item) {
            var otherMenu = other.querySelector('.byo-megamenu');
            if (otherMenu) {
              otherMenu.style.display = 'none';
              otherMenu.style.left = '0';
              otherMenu.classList.remove('byo-animate-in');
            }
          }
        });
        menu.classList.remove('byo-animate-in');
        menu.style.display = 'flex';
        menu.offsetHeight;
        menu.classList.add('byo-animate-in');
        adjustMenuPosition(menu);
        // Focus first focusable element inside the megamenu
        var firstLink = menu.querySelector('a[href], button, [tabindex="0"]');
        if (firstLink) firstLink.focus();
      }
    });
  });

  /* ── Keyboard: navigate within megamenus (Escape, ArrowDown/Up, Tab) ── */
  document.querySelectorAll('.byo-megamenu').forEach(function(menu) {
    menu.addEventListener('keydown', function(e) {
      var navItem = menu.closest('.byo-nav-item');

      // Escape — close menu, return focus to trigger
      if (e.key === 'Escape') {
        e.preventDefault();
        closeMegamenu(navItem);
        return;
      }

      // ArrowDown / ArrowUp — move between focusable items
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var focusables = Array.from(menu.querySelectorAll('a[href], button, [tabindex="0"]'));
        if (focusables.length === 0) return;
        var idx = focusables.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = idx < focusables.length - 1 ? idx + 1 : 0;
          focusables[next].focus();
        } else {
          e.preventDefault();
          var prev = idx > 0 ? idx - 1 : focusables.length - 1;
          focusables[prev].focus();
        }
        return;
      }

      // Tab on last item — close menu
      if (e.key === 'Tab' && !e.shiftKey) {
        var focusables = Array.from(menu.querySelectorAll('a[href], button, [tabindex="0"]'));
        if (focusables.length && document.activeElement === focusables[focusables.length - 1]) {
          closeMegamenu(navItem);
        }
      }
      // Shift+Tab on first item — close menu
      if (e.key === 'Tab' && e.shiftKey) {
        var focusables = Array.from(menu.querySelectorAll('a[href], button, [tabindex="0"]'));
        if (focusables.length && document.activeElement === focusables[0]) {
          closeMegamenu(navItem);
        }
      }
    });
  });

  /* ── Mobile nav drawer ── */
  var mobileNav = document.getElementById('byoMobileNav');
  var mobileToggle = document.getElementById('byoMobileToggle');
  var mobileNavClose = document.getElementById('byoMobileNavClose');
  var mobileNavOverlay = document.getElementById('byoMobileNavOverlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.style.display = 'flex';
    mobileNav.offsetHeight; // force reflow so transitions run
    mobileNav.classList.add('byo-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('byo-open');
    document.body.style.overflow = '';
    setTimeout(function() {
      if (!mobileNav.classList.contains('byo-open')) mobileNav.style.display = 'none';
    }, 320);
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* ── Keyboard: Escape closes mobile drawer ── */
  if (mobileNav) {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('byo-open')) {
        closeMobileNav();
        if (mobileToggle) mobileToggle.focus();
      }
    });
  }

  /* ── Mobile toggle buttons (top-level + subsections) ── */
  document.querySelectorAll('.byo-mobile-toggle-link, .byo-mobile-submenu-toggle[data-target]').forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      var targetId = toggle.getAttribute('data-target');
      var target = document.getElementById(targetId);
      if (!target) return;
      toggle.classList.toggle('byo-expanded');
      target.classList.toggle('byo-open');
    });
  });

  /* ── Search modal: ensure our buttons open the theme's search drawer ──
     The theme's ModalDialog binds click handlers to [data-a11y-dialog-show]
     at init time, but timing may cause our buttons to be missed.
     We explicitly call the modal's public .open() method as a reliable fallback. */
  var searchModal = document.getElementById('modal-search');
  if (searchModal) {
    document.querySelectorAll('.byo-search-input-btn, .byo-mobile-search-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof searchModal.open === 'function') {
          searchModal.open();
        }
      });
    });
  }

}
if (document.querySelector('.byo-header')) byoHeaderInit();
else document.addEventListener('DOMContentLoaded', byoHeaderInit);
})();
